import { CryptoKey } from "../utils/emunData";
import Crypto from "../utils/crypto";
import { httpGet, httpPost, httpPut, httpDelete } from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getSynctoolList() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/synctool/list`;
    return httpGet(apiUrl);
  }

  updateSynctoolName(id, name) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/synctool/name`;
    return httpPut(apiUrl, {
      name,
      synctoolID: id,
    });
  }

  deleteSynctool(id) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/synctool/?synctoolID=${id}`;
    return httpDelete(apiUrl);
  }

  sendAbaxisTest() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/syncTool/request/vetScan/test`;
    return httpGet(apiUrl);
  }

  getAbaxisPdf(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/syncTool/request/vetScan/pdf`;
    return httpPost(apiUrl, data);
  }
}
